/**
 * @generated SignedSource<<035d64212bd2516ee41d4e4e51b50c04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateDetailsSectionContentfulRelayFragment$data = {
  readonly pluginModuleKey: string | null | undefined;
  readonly templateNameExternal: string | null | undefined;
  readonly templateTypeCollection: {
    readonly items: ReadonlyArray<{
      readonly sys: {
        readonly id: string;
      };
      readonly templateTypeNameExternal: string | null | undefined;
    } | null | undefined>;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"templateDescriptionContentfulRelayFragment" | "templatePreviewContentfulRelayFragment" | "templateRelatedTemplatesContentfulRelayFragment" | "templateTabbedSectionContentfulRelayFragment">;
  readonly " $fragmentType": "templateDetailsSectionContentfulRelayFragment";
};
export type templateDetailsSectionContentfulRelayFragment$key = {
  readonly " $data"?: templateDetailsSectionContentfulRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateDetailsSectionContentfulRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateDetailsSectionContentfulRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateNameExternal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pluginModuleKey",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductTemplateTemplateTypeCollection",
      "kind": "LinkedField",
      "name": "templateTypeCollection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TaxonomyTemplateType",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Sys",
              "kind": "LinkedField",
              "name": "sys",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "templateTypeNameExternal",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templatePreviewContentfulRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateDescriptionContentfulRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateTabbedSectionContentfulRelayFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "templateRelatedTemplatesContentfulRelayFragment"
    }
  ],
  "type": "ProductTemplate",
  "abstractKey": null
};

(node as any).hash = "e8b8a2fa5d16d077e413ac61f87dea66";

export default node;
